import { useEffect, useRef, useState } from "react";
import "./RiTreaty.scss";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest";
import { ScaleLoader } from "react-spinners";
import { IoAdd, IoCloseSharp, IoCheckmarkDone, IoListCircleSharp, IoArrowBackSharp, IoCopy } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Chip,
    Popover,
    Tooltip,
    TablePagination,
} from "@mui/material";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { FaSave } from "react-icons/fa";
import { showToast } from "../../../toastService";
import { MdAdd, MdAlternateEmail, MdClose, MdDelete, MdEdit, MdNumbers, MdOutlineMenuOpen } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { fetchClientsBySearch, formatAmountsToDecimals, formatStringToNumberV2, generateUniqueCode, logData, removeSpacesAndTabs } from "../../../utils/genericFunctions";
import moment from "moment";
import { qilloIconMap } from "../../../utils/iconMapping";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent";
import { LuListVideo } from "react-icons/lu";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch";
import { useNavigate } from "react-router-dom";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import { width } from "@mui/system";
import { CustomRadioGroup } from "../../../components/radio/CustomRadioGroup";
import { PiChecksBold } from "react-icons/pi";
import numeral from "numeral";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages";


const RiTreaty = () => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const navigate = useNavigate();
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const actionsMenuRef = useRef(null);
    const [openOptions, setOpenOptions] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [searchTermIntegration, setSearchTermIntegration] = useState("");
    const [searchTermTypes, setSearchTermTypes] = useState("");
    const [currentAction, setCurrentAction] = useState(null);
    const [searchTermTreaty, setSearchTermTreaty] = useState("");
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        new_doc_status: "",
    });

    const [profileLimitValues, setProfileLimitValues] = useState([]);
    const limitsToCheck = ["GBRI00", "GBRI01", "GBRI02"];

    const [currencies, setCurrencies] = useState([]);

    const [validationMsgDialog, setValidationMsgDialog] = useState(false);
    const [validationMessagesResult, setValidationMessagesResult] = useState({});

    const productRef = useRef(null);
    const coverRef = useRef(null);
    const participantRef = useRef(null);

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const id = popoverOpen ? 'popover' : undefined;

    const [currentView, setCurrentView] = useState("covers");
    const [treatyCoverLimits, setTreatyCoverLimits] = useState([]);
    const [selectedCoverLimit, setSelectedCoverLimit] = useState(null);

    const [selectedPartType, setSelectedPartType] = useState(null);
    const [partTypes, setPartTypes] = useState([]);

    const [chargesDialogOpen, setChargesDialogOpen] = useState(false);

    const [definedCharges, setDefinedCharges] = useState([]);
    const [selectedDefinedCharge, setSelectedDefinedCharge] = useState(null);
    const [selectedDefinedChargeRate, setSelectedDefinedChargeRate] = useState(0);
    const [selectedDefinedTax, setSelectedDefinedTax] = useState(null);
    const [selectedDefinedTaxRate, setSelectedDefinedTaxRate] = useState(0);

    const [participantCharges, setParticipantCharges] = useState([]);
    const [selectedPartChargeRow, setSelectedPartChargeRow] = useState(null);

    const [totalSurplus, setTotalSurplus] = useState(0);
    const [totalQs, setTotalQs] = useState(0);
    const [totalCqs, setTotalCqs] = useState(0);

    const [qsParticipants, setQsParticipants] = useState([]);
    const [cqsParticipants, setCqsParticipants] = useState([]);
    const [surplusParticipants, setSurplusParticipants] = useState([]);

    const [selectedParticipant, setSelectedParticipant] = useState(null);
    const [participantPerc, setParticipantPerc] = useState(0);

    const [searchTermCover, setSearchTermCover] = useState("");
    const [coversPage, setCoversPage] = useState(0);
    const [rowsPerPageCovers, setRowsPerPageCovers] = useState(4);

    const [treatyCovers, setTreatyCovers] = useState([]);
    const [selectedTreatyCover, setSelectedTreatyCover] = useState(null);

    const [treaties, setTreaties] = useState([]);

    const [selectedChannelType, setSelectedChannelType] = useState(null);
    const [channelTypes, setChannelTypes] = useState([]);
    const [selectedSubClassCover, setSelectedSubClassCover] = useState(null);
    const [subClassCovers, setSubClassCovers] = useState([]);
    const [selectedRiskCatg, setSelectedRiskCatg] = useState(null);
    const [riskCategories, setRiskCategories] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productSubClasses, setProductSubClasses] = useState([]);
    const [selectedTreaty, setSelectedTreaty] = useState(null);
    const [treatyLines, setTreatyLines] = useState([]);
    const [selectedLineType, setSelectedLineType] = useState(null);

    const handleTreatyData = (field, value) => {
        setSelectedTreaty((prev) => {
            return { ...prev, [field]: value };
        });

        setTreaties((prev) =>
            prev.map((item) =>
                item._id === selectedTreaty?._id
                    ? { ...item, [field]: value, changed_xx: "Y" }
                    : item
            )
        );
    };


    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "approveTreaty") {
                // do all validations
                let validateResponse = null;
                try {
                    setIsProcessing(true);
                    validateResponse = await newRequest.get(`/treaty/validate/${selectedTreaty?._id}`);
                    setIsProcessing(false);
                } catch (error) {
                    setIsProcessing(false);
                    if (error.code === 'ECONNABORTED') {
                        console.error("Request timed out!");
                        showToast(t('requestTimedOut'), "error");
                    } else {
                        console.error("Other error:", error.message);
                        showToast(error.message, "error");
                    }
                }

                if (validateResponse.data.result_status === "error") {
                    setIsProcessing(false);
                    setIsConfirmDialogOpen(false);
                    setValidationMessagesResult(validateResponse.data);
                    setValidationMsgDialog(true);
                    return;
                } else {
                    setIsProcessing(true);
                    await newRequest.put(`/treaty/upd/${selectedTreaty?._id}`, { treaty_status: "Approved" });
                    handleTreatyData("treaty_status", "Approved");
                    setIsProcessing(false);
                    showToast(t('treatyApproved'), "success");
                }

            } else if (confirmDialogAction === "underReview") {
                setIsProcessing(true);
                await newRequest.put(`/treaty/upd/${selectedTreaty?._id}`, { treaty_status: "Under Review" });
                handleTreatyData("treaty_status", "Under Review");
                setIsProcessing(false);
                showToast(t('setUnderReview'), "success");
            } else if (confirmDialogAction === "suspend") {
                setIsProcessing(true);
                await newRequest.put(`/treaty/upd/${selectedTreaty?._id}`, { treaty_status: "Suspended" });
                handleTreatyData("treaty_status", "Suspended");
                setIsProcessing(false);
                showToast(t('suspended'), "success");
            } else if (confirmDialogAction === "deleteTreatyCover") {
                setIsProcessing(true);
                const res = await newRequest.delete(`/treatyCover/del/${objectToAction?.object_id}`);
                setIsProcessing(false);
                if (res.data?.msg === "deleted") {
                    setTreatyCovers((prev) => prev.filter(param => param._id !== objectToAction?.object_id));
                    showToast(t('deleted'), "success");
                } else {
                    showToast("Error removing cover!", "error");
                }
            } else if (confirmDialogAction === "deleteTreatyLimit") {
                try {
                    setIsProcessing(true);
                    const res = await newRequest.delete(`/treatyCover/deleteCoverLimit/${selectedTreatyCover._id}/${objectToAction?.object_id}`);
                    setIsProcessing(false);
                    if (res.data?.msg === "deleted") {
                        setTreatyCoverLimits((prev) => prev.filter(param => param._id !== objectToAction?.object_id));
                        showToast(t('deleted'), "success");
                    } else {
                        showToast("Error removing limit!", "error");
                    }
                } catch (error) {
                    console.log(error);
                }
            }

        } catch (err) {
            console.log(err);
        } 
        setIsConfirmDialogOpen(false);
    };

    const fetchTreaties = async (e) => {
        try {
            setIsProcessing(true);
            const res = await newRequest.post("/treaty/findAll", { treaty_status: "", result_limit: 8 });
            setTreaties(res.data);
            setSelectedTreaty({
                ...res.data[0],
                treaty_fm: moment(res.data[0]?.treaty_fm).format("YYYY-MM-DD"),
                treaty_to: moment(res.data[0]?.treaty_to).format("YYYY-MM-DD")
            });
            setTreatyLines(res.data[0]?.treaty_lines);
            setSelectedLineType(res.data[0]?.treaty_lines[0]);
            setCoversPage(0);
            await fetchTreatyCovers(res.data[0]?.treaty_code, res.data[0]?.treaty_lines[0]?.line_type);
        } catch (error) {
            console.log(error);
        } finally {
            setIsProcessing(false);
        }
    };

    const fetchTreatyCovers = async (treatyCode, lineType) => {
        try {
            setIsProcessing(true);
            setTreatyCovers([]);
            const res = await newRequest.post("/treatyCover/findAll", { cover_treaty_code: treatyCode, cover_line_type: lineType, cover_cc_code: "", result_limit: 1000 });

            setTreatyCovers(res.data);
            // console.log(`TreatyCovers  ${JSON.stringify(res.data, null, 2)}`);

            setSelectedTreatyCover(null);
            setSelectedTreatyCover({
                ...res.data[0],
                cover_treaty_fm: moment(res.data[0]?.cover_treaty_fm).format("YYYY-MM-DD"),
                cover_treaty_to: moment(res.data[0]?.cover_treaty_to).format("YYYY-MM-DD")
            });
            setTreatyCoverLimits([]);
            const formattedData = res.data[0]?.cover_limits?.map(item => ({
                ...item,
                limit_si_fm: formatNumber(item.limit_si_fm),
                limit_si_to: formatNumber(item.limit_si_to),
                limit_retention: formatNumber(item.limit_retention),
                limit_lines: formatNumber(item.limit_lines, 0),
                limit_cqs_perc: formatNumber(item.limit_cqs_perc),
                limit_qs_perc: formatNumber(item.limit_qs_perc),
            }));
            setTreatyCoverLimits(formattedData);
            setSelectedCoverLimit(null);
            setSelectedCoverLimit(formattedData[0]);

        } catch (error) {
            console.log(error);
        } finally {
            setIsProcessing(false);
        }
    };


    const fetchProductSubClasses = async () => {
        try {
            const res = await newRequest.get("/uwProductSc/prodsc");
            const options = res.data?.map((cover) => ({
                pr_code: cover?.ps_pr_code,
                mc_code: cover?.ps_mc_code,
                sc_code: cover?.ps_sc_code,
                value: cover?._id,
                label: `PRODUCT ${cover?.ps_pr_code} - ${cover?.pr_code_xx} [MC ${cover?.ps_mc_code}, SC ${cover?.ps_sc_code}]`,
            }));
            setProductSubClasses(options);
        } catch (error) {
            console.error("Error fetching product covers :", error);
        }
    };

    const fetchPartType = async () => {
        try {
            const options = ["QS", "CQS"]?.map((val) => ({
                value: val,
                label: val,
            }));
            setPartTypes(options);
        } catch (error) {
            console.error("Error fetching product covers :", error);
        }
    };

    const fetchCharges = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Charges" });
            const options = res.data?.map((val) => ({
                value: val?.sys_code,
                label: val?.sys_name,
            }));
            setDefinedCharges(options);
        } catch (error) {
            console.error("Error fetching report templates types:", error);
        }
    };

    const fetchRiskCategories = async (mcCode, scCode, ccCode) => {
        try {
            const res = await newRequest.post("/uwSubClassCover/findPerSubClass", {
                cc_mc_code: mcCode,
                cc_sc_code: scCode,
                cc_code: ccCode,
            });
            let options = res.data?.cc_categories?.map((catg) => ({
                value: catg,
                label: catg,
            }));
            setRiskCategories([]);
            options = [{ mc_code: "!", sc_code: "!", cc_code: "!", value: "!", label: "!" }
                , ...options,
            { mc_code: "~~~~~", sc_code: "~~~~~", cc_code: "~~~~~", value: "~~~~~", label: "~~~~~" }];
            setRiskCategories(options);
        } catch (error) {
            console.error("Error fetching product covers :", error);
        }
    };

    const fetchSubClassCovers = async (mcCode, scCode) => {
        try {
            const res = await newRequest.post(
                "/uwSubClassCover/findAll",
                {
                    cc_mc_code: mcCode,
                    cc_sc_code: scCode,
                }
            );

            const options = res.data?.map((cover) => ({
                mc_code: cover?.cc_mc_code,
                sc_code: cover?.cc_sc_code,
                cc_code: cover?.cc_code,
                cc_desc: cover?.cc_desc,
                value: cover?.cc_code,
                label: `${cover?.cc_name} [${cover?.cc_code}]`,
            }));
            setSubClassCovers(options);
        } catch (error) {
            console.error("Error fetching product covers :", error);
        }
    };

    const fetchCurrencies = async () => {
        try {
            const res = await newRequest.get("/glCurrency/findAll");
            const options = res.data.map((currency) => ({
                value: currency.cur_code,
                label: currency.cur_name,
            }));
            setCurrencies(options);
        } catch (error) {
            console.error("Error fetching entity types:", error);
        }
    };

    const handleSearchTreaties = async () => {
        try {
            setIsLoading(true);
            if (searchTermTreaty) {
                const res = await newRequest.post("/treaty/search", { search_input: searchTermTreaty });
                setTreaties(res.data);
            } else {
                fetchTreaties();
            }
        } catch (error) {
            console.error("Error searching data:", error);
        } finally {
            setIsLoading(false);
        }
    };


    const fetchChannelTypes = async () => {
        try {
            const res = await newRequest.post("/sysCode/findAll", { sys_type: "Channel Type" });
            let options = res.data?.map((mode) => ({
                value: mode?.sys_code,
                label: mode?.sys_name,
            }));

            // Add "!" at the beginning and "~~~~~" at the end
            options = [{ value: "!", label: "!" }, ...options, { value: "~~~~~", label: "~~~~~" }];
            setChannelTypes(options);
        } catch (error) {
            console.error("Error fetching receipt modes :", error);
        }
    };

    const handleCoverChange = (rowId, field, selectedOption) => {
        try {
            const updatedItems = treatyCovers?.map(item =>
                item._id === rowId ? { ...item, [field]: selectedOption ? selectedOption.value : "", changed_xx: "Y" } : item
            );
            setTreatyCovers(updatedItems);
        } catch (error) {
            console.log(error);
        }
    };

    const handleFacAllocation = (value, rowId, field) => {
        setTreatyCovers((prevData) =>
            prevData.map((item) =>
                item._id === rowId
                    ? { ...item, [field]: value, changed_xx: "Y" }
                    : item
            )
        );
    };

    const handleCoverLimitsChange = (rowId, field, selectedOption) => {
        try {
            const updatedItems = treatyCoverLimits?.map(item =>
                item._id === rowId ? { ...item, [field]: selectedOption ? selectedOption.value : "", changed_xx: "Y" } : item
            );
            setTreatyCoverLimits(updatedItems);
        } catch (error) {
            console.log(error);
        }
    };

    const handleCoverLimitsCqsQs = (value, rowId, field) => {
        setTreatyCoverLimits((prev) =>
            prev?.map((item) =>
                item._id === rowId
                    ? { ...item, [field]: value, changed_xx: "Y" }
                    : item
            )
        );
        setSelectedCoverLimit((prev) => { return { ...prev, [field]: value }; });
    };


    const handleCoverInputsChange = (e, rowId) => {
        try {
            const { name, value } = e.target;
            const updatedData = [...treatyCoverLimits];
            const rowIndex = updatedData.findIndex(item => item._id === rowId);

            if (rowIndex === -1) {
                throw new Error('row not found');
            }
            updatedData[rowIndex][name] = value;
            updatedData[rowIndex]["changed_xx"] = "Y";

            setTreatyCoverLimits(updatedData);
        } catch (error) {
            console.log(error);
        }
    };

    const handleCoverLimitsBlur = (rowId, field) => {
        try {
            const updatedData = [...treatyCoverLimits];
            const rowIndex = updatedData.findIndex(item => item._id === rowId);

            if (rowIndex === -1) {
                throw new Error('row not found');
            }
            let value = updatedData[rowIndex][field];
            value = formatNumber(formatStringToNumberV2(value));
            updatedData[rowIndex][field] = value;
            setTreatyCoverLimits(updatedData);
        } catch (error) {
            console.log(error);
        }
    };



    const formatNumber = (value, decimals = 2) => {
        try {
            if (isNaN(formatStringToNumberV2(value))) return value;
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: decimals
            }).format(value);
        } catch (error) {
            console.log(error)
        }
    };


    // COVERS
    const handleCoversChangePage = (event, newPage) => {
        setCoversPage(newPage);
    };

    const handleCoversChangeRowsPerPage = (event) => {
        setRowsPerPageCovers(parseInt(event.target.value, 4));
        setCoversPage(0);
    };


    const filteredCoversData = treatyCovers?.filter(
        (item) =>
            item.cover_cc_code?.toLowerCase().includes(searchTermCover.toLowerCase()) ||
            item.cover_pr_code?.toLowerCase().includes(searchTermCover.toLowerCase()) ||
            item.cover_sc_code?.toLowerCase().includes(searchTermCover.toLowerCase())
    );

    const slicedCoversData = filteredCoversData.slice(
        coversPage * rowsPerPageCovers,
        coversPage * rowsPerPageCovers + rowsPerPageCovers
    );

    // COVERS
    const saveRecord = async (e) => {
        try {
            setIsProcessing(true);

            // update treaty header
            await newRequest.put(`/treaty/upd/${selectedTreaty?._id}`, selectedTreaty);

            if (Array.isArray(treatyCovers)) {
                if (treatyCovers?.length > 0) {
                    const changedCovers = treatyCovers?.filter((obj) => obj.changed_xx === "Y");
                    for (let i = 0; i < changedCovers.length; i++) {
                        await newRequest.put(`/treatyCover/upd/${changedCovers[i]?._id}`, {
                            cover_channel_fm: changedCovers[i]?.cover_channel_fm,
                            cover_channel_to: changedCovers[i]?.cover_channel_to,
                            cover_fac_allocation: changedCovers[i]?.cover_fac_allocation,
                        });
                    }
                }
            }

            if (Array.isArray(treatyCoverLimits)) {
                if (treatyCoverLimits?.length > 0) {
                    const changedLimits = treatyCoverLimits?.filter((obj) => obj.changed_xx === "Y");
                    for (let i = 0; i < changedLimits.length; i++) {
                        await newRequest.put(`/treatyCover/updateCoverLimit/${selectedTreatyCover._id}/${changedLimits[i]?._id}`, {
                            limit_si_fm: formatStringToNumberV2(changedLimits[i]?.limit_si_fm),
                            limit_si_to: formatStringToNumberV2(changedLimits[i]?.limit_si_to),
                            limit_catg_fm: changedLimits[i]?.limit_catg_fm,
                            limit_catg_to: changedLimits[i]?.limit_catg_to,
                            limit_retention: formatStringToNumberV2(changedLimits[i]?.limit_retention),
                            limit_lines: formatStringToNumberV2(changedLimits[i]?.limit_lines),
                            limit_cqs: changedLimits[i]?.limit_cqs,
                            limit_cqs_perc: changedLimits[i]?.limit_cqs === "Y" ? formatStringToNumberV2(changedLimits[i]?.limit_cqs_perc) : 0,
                            limit_qs: changedLimits[i]?.limit_qs,
                            limit_qs_perc: changedLimits[i]?.limit_qs === "Y" ? formatStringToNumberV2(changedLimits[i]?.limit_qs_perc) : 0
                        });
                    }
                }
            }

            setIsProcessing(false);
            showToast(t('saved'), "success");
        } catch (error) {
            console.log(error);
        }
    };

    // PARTICIPANT CHARGES
    const handlePartCharge = (eOrValue, id, field) => {
        try {
            const newData = [...participantCharges];
            const index = newData.findIndex((x) => x._id === id);
            if (index === -1) return;

            let nextValue;

            // Native input event
            if (eOrValue?.target) {
                nextValue = eOrValue.target.value;
            }
            // Select-like object { value, label }
            else if (eOrValue && typeof eOrValue === "object" && "value" in eOrValue) {
                nextValue = eOrValue.value;
            }
            // Primitive value (string/number/boolean) from custom components
            else {
                nextValue = eOrValue;
            }

            newData[index] = { ...newData[index], [field]: nextValue, changed_xx: "Y" };
            setParticipantCharges(newData);
        } catch (error) {
            console.log(error);
        }
    };


    const handlePartChargeBlur = (id, field) => {
        try {
            const updatedData = [...participantCharges];
            const index = updatedData.findIndex(smi => smi._id === id);
            if (index !== -1) {
                const value = formatStringToNumberV2(updatedData[index][field]);
                updatedData[index][field] = formatNumber(value)
                setParticipantCharges(updatedData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const updateParticipantCharges = async () => {
        try {
            let url = null;

            console.log(`destination ${selectedParticipant?.destination}`);
            if (selectedParticipant?.destination === "surplus") {
                url = "/treatyCover/addSurplusCharge";
            } else if (selectedParticipant?.destination === "qs") {
                url = "/treatyCover/addQsCharge";
            } else if (selectedParticipant?.destination === "cqs") {
                url = "/treatyCover/addCqsCharge";
            }

            if (!url) {
                showToast("Unable to set destination url", "error");
                return;
            }

            if (!selectedParticipant?.docid) {
                showToast("Participant document id not found", "error");
                return;
            }

            // update batch lines
            const changedLines = participantCharges.filter((obj) => obj.changed_xx === "Y");
            logData("changedLines", changedLines);
            // Loop through each object in the array
            for (let i = 0; i < changedLines.length; i++) {
                await newRequest.post(url, {
                    cover_docid: selectedTreatyCover?._id,
                    limit_docid: selectedCoverLimit?._id,
                    participant_id: selectedParticipant?.docid,
                    charge_code: changedLines[i]?.charge_code,
                    charge_rate: parseFloat(formatNumber((changedLines[i]?.charge_rate || 0), 6)),
                    charge_tax_code: changedLines[i]?.charge_tax_code || null,
                    charge_tax_rate: !changedLines[i]?.charge_tax_code ? 0 : parseFloat(formatNumber((changedLines[i]?.charge_tax_rate || 0), 6)),
                    charge_basis: changedLines[i]?.charge_basis
                });
            }
            setChargesDialogOpen(false);
            showToast(t('updated'), "success");
        } catch (error) {
            console.log(error);
        }
    };
    // PARTICIPANT CHARGES

    // ADDING PARTICIPANTS
    const notify = (title, text) => {
        setNotifyDialogTitle(title);
        setNotifyDialogText(text);
        setIsNotifyDialogOpen(true);
    };

    const resetParticipantForm = () => {
        setSelectedParticipant(null);
        setSelectedPartType(null);
        setParticipantPerc(0);
        participantRef.current?.focus?.();
    };

    const getParticipantConfig = () => {
        const isRetention = selectedLineType?.line_type === "Retention";
        const partType = selectedPartType?.value;

        if (!isRetention) {
            return {
                endpoint: "/treatyCover/addSurplusEntity",
                listSetter: setSurplusParticipants,
                limitsKey: "limit_surplus_participants",
                entity_column: "surplus_ent_code",
                rate_column: "surplus_rate",
                part_type: "surplus"
            };
        }

        if (partType === "QS") {
            return {
                endpoint: "/treatyCover/addQSEntity",
                listSetter: setQsParticipants,
                limitsKey: "limit_qs_participants",
                entity_column: "qs_ent_code",
                rate_column: "qs_rate",
                part_type: "qs"
            };
        }

        if (partType === "CQS") {
            return {
                endpoint: "/treatyCover/addCQSEntity",
                listSetter: setCqsParticipants,
                limitsKey: "limit_cqs_participants",
                entity_column: "cqs_ent_code",
                rate_column: "cqs_rate",
                part_type: "cqs"
            };
        }

        return null;
    };

    const validateParticipantInput = () => {
        if (!selectedParticipant) {
            notify("Note!", "Please select entity");
            return false;
        }

        if (!participantPerc) {
            notify("Note!", "Please enter percentage");
            return false;
        }

        const isRetention = selectedLineType?.line_type === "Retention";
        const needsPartType =
            isRetention &&
            (selectedCoverLimit?.limit_qs === "Y" || selectedCoverLimit?.limit_cqs === "Y");

        if (needsPartType && !selectedPartType) {
            notify("Note!", "Please select participant type");
            return false;
        }

        return true;
    };

    const addParticipant = async () => {
        if (!validateParticipantInput()) return;

        const config = getParticipantConfig();

        if (!config) {
            // retention but no QS/CQS chosen (or unsupported type)
            notify("Note!", "Please select participant type");
            return;
        }
        let newTotal = 0;
        let alertMsg = "";
        if (config?.part_type === "surplus") {
            newTotal = totalSurplus + participantPerc;
            alertMsg = t('treatySetupAllocError', {
                param1: config?.part_type?.toUpperCase(),
                param2: numeral(totalSurplus).format("0,0.00"),
                param3: selectedParticipant?.ent_name,
                param4: `${numeral(participantPerc).format("0,0.00")}%`,
                param5: `${numeral(newTotal).format("0,0.00")}%`,
            });
        } else if (config?.part_type === "qs") {
            newTotal = totalQs + participantPerc;
            alertMsg = t('treatySetupAllocError', {
                param1: config?.part_type?.toUpperCase(),
                param2: numeral(totalQs).format("0,0.00"),
                param3: selectedParticipant?.ent_name,
                param4: `${numeral(participantPerc).format("0,0.00")}%`,
                param5: `${numeral(newTotal).format("0,0.00")}%`,
            });
        } else if (config?.part_type === "cqs") {
            newTotal = totalCqs + participantPerc;
            alertMsg = t('treatySetupAllocError', {
                param1: config?.part_type?.toUpperCase(),
                param2: numeral(totalCqs).format("0,0.00"),
                param3: selectedParticipant?.ent_name,
                param4: `${numeral(participantPerc).format("0,0.00")}%`,
                param5: `${numeral(newTotal).format("0,0.00")}%`,
            });
        }

        if (newTotal > 100) {
            setNotifyDialogTitle(t('note'));
            setNotifyDialogText(alertMsg);
            setIsNotifyDialogOpen(true);
            return;
        }

        const payload = {
            cover_docid: selectedTreatyCover?._id,
            limit_docid: selectedCoverLimit?._id,
            [config?.entity_column]: selectedParticipant?.value,
            [config?.rate_column]: participantPerc,
        };

        // console.log(`endpoint... ${config.endpoint}`);
        // logData("payload", payload);

        const res = await newRequest.post(config.endpoint, payload);

        if (res.data?.msg === "added") {
            const newParticipant = res.data.doc;

            config.listSetter((prev) => [...prev, newParticipant]);

            setTreatyCoverLimits((prev) => {
                if (!prev) return prev;
                return {
                    ...prev,
                    [config.limitsKey]: [...(prev[config.limitsKey] || []), newParticipant],
                };
            });

            // for "added" you were not clearing selectedPartType previously for Surplus/QS/CQS.
            // keep behavior consistent with your original code:
            setSelectedParticipant(null);
            setParticipantPerc(0);
            participantRef.current?.focus?.();

            showToast("Added", "success");
            return;
        }

        if (res.data?.msg === "exists") {
            resetParticipantForm();
            showToast("Cover already added", "success");
            return;
        }

        showToast(res.data?.msg || "Error", "error");
    };
    // END OF PARTICIPANTS

    const getLimitValue = (limitCode) => {
        try {
            const limit = profileLimitValues.find(l => l.limit_code === limitCode);
            return limit ? limit.limit_yn : null;
        } catch (error) {
            console.log(error)
        }
    };

    const fetchPopulateProfile = async () => {
        try {
            const limits = await newRequest.post("/adProfile/checkValues", { module_code: "gb", limit_codes: limitsToCheck });
            setProfileLimitValues(limits.data);
        } catch (error) {
            console.error("Error fetching profile limits :", error);
        }
    };

    // FOR UPDATING PARTICIPANT CHARGES
    useEffect(() => {
        // console.log(`charges updating for `);

        // logData("participant", {
        //     cover_docid: selectedTreatyCover?._id,
        //     limit_docid: selectedCoverLimit?._id,
        //     participant_id: selectedParticipant?.docid,
        //     destination: selectedParticipant?.destination
        // });

        if (selectedParticipant?.destination === "qs") {
            setQsParticipants((prevData) =>
                prevData.map((item) =>
                    item._id === selectedParticipant?.docid
                        ? { ...item, qs_charges: participantCharges }
                        : item
                )
            );
        } else if (selectedParticipant?.destination === "cqs") {
            setCqsParticipants((prevData) =>
                prevData.map((item) =>
                    item._id === selectedParticipant?.docid
                        ? { ...item, qs_charges: participantCharges }
                        : item
                )
            );
        } else if (selectedParticipant?.destination === "surplus") {
            setSurplusParticipants((prevData) =>
                prevData.map((item) =>
                    item._id === selectedParticipant?.docid
                        ? { ...item, qs_charges: participantCharges }
                        : item
                )
            );
        }

    }, [participantCharges]);

    // CALCULATE TOTAL ALLOCATED PARTICIPANT ALLOCATION
    useEffect(() => {
        const total = surplusParticipants?.reduce((sum, item) => {
            return sum + parseFloat(item?.surplus_rate);
        }, 0);
        setTotalSurplus(total);
    }, [surplusParticipants]);

    useEffect(() => {
        const total = qsParticipants?.reduce((sum, item) => {
            return sum + parseFloat(item?.qs_rate);
        }, 0);
        setTotalQs(total);
    }, [qsParticipants]);

    useEffect(() => {
        const total = cqsParticipants?.reduce((sum, item) => {
            return sum + parseFloat(item?.cqs_rate);
        }, 0);
        setTotalCqs(total);
    }, [cqsParticipants]);

    useEffect(() => {
        function handleClickOutside(event) {
            // for hiding actions menu
            if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
                setOpenOptions(false);
            }
        }

        // Add event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (selectedProduct) {
            setSelectedSubClassCover(null);
            setSubClassCovers([]);
            fetchSubClassCovers(selectedProduct?.mc_code, selectedProduct?.sc_code);
        }
    }, [selectedProduct]);

    useEffect(() => {
        fetchTreaties();
        fetchProductSubClasses();
        fetchChannelTypes();
        fetchCurrencies();
        fetchPartType();
        fetchCharges();
        fetchPopulateProfile();
    }, []);






    return (
        <div className='ri-treaty'>
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <motion.div
                    className="ri-treaty-main-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="ri-treaty-center-wrapper">
                        <div className="center-navbar">
                            <div className="navbar-left">
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "1px" }}>
                                    <h1 className="page-title">{selectedTreaty?.treaty_name?.toUpperCase()}</h1>
                                    <h1 className="sub-title soft" style={{ fontSize: "12px" }}>{selectedTreaty?.treaty_code}</h1>
                                </div>
                            </div>
                            <div className="navbar-right">
                                <span className={`status ${removeSpacesAndTabs(selectedTreaty?.treaty_status)}`}>{`${t('status').toUpperCase()} ${selectedTreaty?.treaty_status}`}</span>
                                {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="both"
                                        variant="tint"
                                        color="#00D37F"
                                        tooltip="Save changes"
                                        endIcon={<FaSave />}
                                        onClick={saveRecord}>
                                        {t('save')}
                                    </CustomLoadingButton>}
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="both"
                                        variant="tint"
                                        color="#0ea5a4"
                                        tooltip={`${t('copyParam', { param1: selectedTreaty?.treaty_name })}`}
                                        endIcon={<IoCopy />}
                                        onClick={() => {
                                            try {

                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {t('copy')}
                                    </CustomLoadingButton>}
                                <div className="icon-container"
                                    ref={actionsMenuRef}
                                    onClick={(e) => {
                                        try {
                                            e.stopPropagation();
                                            setOpenOptions(!openOptions)
                                        } catch (error) {
                                            console.log(error)
                                        }
                                    }}>
                                    <MdOutlineMenuOpen className="icon" />
                                    {openOptions && (
                                        <div className="dropdown">
                                            {["New", "Suspended", "Under Review"].includes(selectedTreaty?.treaty_status) &&
                                                <div className="dropdown-item"
                                                    onClick={() => {
                                                        try {
                                                            if (getLimitValue("GBRI00") !== "Y") {
                                                                setNotifyDialogTitle("Note!");
                                                                setNotifyDialogText(`GBRI00 - You are not authorized to approve treaty`);
                                                                setIsNotifyDialogOpen(true);
                                                                return;
                                                            } else {
                                                                setConfirmationActiontext(`Do you want to APPROVE this treaty?<br/><br/>Please note treaty will be validated for correctness and completness before approval`);
                                                                setConfirmDialogAction("approveTreaty");
                                                                setIsConfirmDialogOpen(true);
                                                            }

                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                >{t('approveTreaty')}</div>}
                                            {["Approved"].includes(selectedTreaty?.treaty_status) &&
                                                <div className="dropdown-item"
                                                    onClick={() => {
                                                        try {
                                                            if (getLimitValue("GBRI01") !== "Y") {
                                                                setNotifyDialogTitle("Note!");
                                                                setNotifyDialogText(`GBRI01 - You are not authorized to place treaty under review`);
                                                                setIsNotifyDialogOpen(true);
                                                                return;
                                                            } else {
                                                                setConfirmationActiontext(`Do you want to place this treaty UNDER REVIEW?<br/>Please note allocations using this treaty will not be approved until treaty is in Approved state`);
                                                                setConfirmDialogAction("underReview");
                                                                setIsConfirmDialogOpen(true);
                                                            }
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                >{t('underReview')}</div>}
                                            {["Approved"].includes(selectedTreaty?.treaty_status) &&
                                                <div className="dropdown-item"
                                                    onClick={() => {
                                                        try {
                                                            if (getLimitValue("GBRI02") !== "Y") {
                                                                setNotifyDialogTitle("Note!");
                                                                setNotifyDialogText(`GBRI02 - You are not authorized to suspend treaty`);
                                                                setIsNotifyDialogOpen(true);
                                                                return;
                                                            } else {
                                                                setConfirmationActiontext(`Do you want to SUSPEND this treaty?<br/>Please note allocations using this treaty will not be approved until treaty is in Approved state`);
                                                                setConfirmDialogAction("suspend");
                                                                setIsConfirmDialogOpen(true);
                                                            }
                                                        } catch (error) {
                                                            console.log(error);
                                                        }
                                                    }}
                                                >{t('suspend')}</div>}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="center-content">
                            <div className="treaty-form-details">
                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                    <label htmlFor="treaty_name" className="form-input-label" style={{ width: "100px" }}>
                                        {t('name').toUpperCase()}
                                    </label>
                                    <input
                                        name="treaty_name"
                                        type="text"
                                        placeholder={t('name').toUpperCase()}
                                        className="form-input-item"
                                        style={{ width: "100%" }}
                                        value={selectedTreaty?.treaty_name}
                                        onChange={(e) => handleTreatyData("treaty_name", e.target.value)}
                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                    />
                                </div>
                                <div className="input-item-with-label">
                                    <label
                                        htmlFor="hd_cur_code"
                                        className="form-dropdown-label"
                                        style={{ width: "max-content" }}
                                    >
                                        {t('currency').toUpperCase()}
                                    </label>
                                    <Select
                                        id="hd_cur_code"
                                        name="hd_cur_code"
                                        menuPortalTarget={document.body}
                                        styles={{
                                            ...(currentTheme === "dark"
                                                ? customSelectStyles_dark
                                                : customSelectStyles_light),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                        }}
                                        width="170px"
                                        value={currencies?.find(option => option.value === selectedTreaty?.treaty_currency) || null}
                                        onChange={(selectedOption) => handleTreatyData("treaty_currency", selectedOption?.value)}
                                        options={currencies}
                                        isSearchable
                                        isDisabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                        placeholder={t('currency').toUpperCase()}
                                    />
                                </div>
                            </div>
                            <div className="treaty-form-details">
                                <div className="input-item-with-label">
                                    <label htmlFor="treaty_code" className="form-input-label" style={{ width: "85px" }}>
                                        {t('code').toUpperCase()}
                                    </label>
                                    <input
                                        name="treaty_code"
                                        type="text"
                                        placeholder={t('code').toUpperCase()}
                                        className="form-input-item"
                                        style={{ width: "200px" }}
                                        value={selectedTreaty?.treaty_code}
                                        onChange={(e) => handleTreatyData("treaty_code", e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div className="input-item-with-label">
                                    <label htmlFor="treaty_fm" className="form-input-label" style={{ width: "max-content" }}>
                                        {t('from').toUpperCase()}
                                    </label>
                                    <input
                                        name="treaty_fm"
                                        type="date"
                                        placeholder={t('from').toUpperCase()}
                                        className="form-input-item"
                                        style={{ width: "170px" }}
                                        value={selectedTreaty?.treaty_fm}
                                        onChange={(e) => {
                                            try {
                                                const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                handleTreatyData("treaty_fm", formattedDate);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                    />
                                </div>
                                <div className="input-item-with-label">
                                    <label htmlFor="treaty_to" className="form-input-label" style={{ width: "max-content" }}>
                                        {t('to').toUpperCase()}
                                    </label>
                                    <input
                                        name="treaty_to"
                                        type="date"
                                        placeholder={t('to').toUpperCase()}
                                        className="form-input-item"
                                        style={{ width: "170px" }}
                                        value={selectedTreaty?.treaty_to}
                                        onChange={(e) => {
                                            try {
                                                const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                                                handleTreatyData("treaty_to", formattedDate);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                    />
                                </div>
                            </div>
                            <ExpandableComponent
                                title={`${t('selected')} ${selectedLineType?.line_type}`}
                                subtitle={`${t('cover').toUpperCase()}: ${selectedTreatyCover?.cover_cc_code || ""} - [${selectedTreatyCover?.cover_cc_code_xx || ""}]`}
                                defaultExpanded={true}
                            >
                                {currentView === "covers" &&
                                    <div className="covers-view">
                                        {treatyLines?.length > 0 &&
                                            <div className="treaty-lines-wrapper">
                                                {treatyLines?.map((line) => {
                                                    const IconComponent = qilloIconMap[line?.line_icon_xx] || treatyLines;
                                                    return (
                                                        <div key={line?.line_type}
                                                            className={`${selectedLineType?.line_type === line?.line_type ? "treaty-line-item current" : "treaty-line-item"}`}
                                                            onClick={async () => {
                                                                try {
                                                                    await fetchTreatyCovers(selectedTreaty?.treaty_code, line?.line_type);
                                                                    setSelectedLineType(line);
                                                                    setCoversPage(0);
                                                                    setSelectedProduct(null);
                                                                    setSelectedSubClassCover(null);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}>
                                                            <IconComponent className="sub-menu-icon" />
                                                            <div className="sub-menu-content">
                                                                <div className="sub-menu-name">{line?.line_type}</div>
                                                                <div className="sub-menu-description">{line?.line_cashcall_limit}</div>
                                                            </div>
                                                            {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                                                    <CircularButton
                                                                        currentTheme={currentTheme}
                                                                        color="#7B1FA2"
                                                                        onClick={(e) => { }}
                                                                        icon={<MdEdit />}
                                                                        width={"30px"}
                                                                        height={"30px"} />
                                                                    {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            color="#E53935"
                                                                            onClick={(e) => { }}
                                                                            icon={<MdDelete />}
                                                                            width={"30px"}
                                                                            height={"30px"} />}
                                                                </div>}
                                                        </div>
                                                    )
                                                })}
                                            </div>}
                                        <hr className="separator-h" />
                                        <div className="covers-wrapper">
                                            {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                <div className="covers-navbar">
                                                    <span className="main-title">{t('covers')}</span>
                                                    <span style={{ display: "flex", gap: "5px", flexDirection: "row", alignItems: "center" }}>
                                                        <Select
                                                            ref={productRef}
                                                            id="product"
                                                            name="product"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="350px"
                                                            value={selectedProduct}
                                                            onChange={(selectedOption) => {
                                                                try {
                                                                    setSelectedProduct(selectedOption);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            options={productSubClasses}
                                                            isSearchable={true}
                                                            placeholder={t('product').toUpperCase()}
                                                        />
                                                        <Select
                                                            ref={coverRef}
                                                            id="cover"
                                                            name="cover"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 9999,
                                                                })
                                                            }}
                                                            width="350px"
                                                            value={selectedSubClassCover}
                                                            onChange={(selectedOption) => {
                                                                try {
                                                                    setSelectedSubClassCover(selectedOption);
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            options={subClassCovers}
                                                            isSearchable={true}
                                                            placeholder={t('cover').toUpperCase()}
                                                        />
                                                        <CircularButton
                                                            currentTheme={currentTheme}
                                                            onClick={async () => {
                                                                try {

                                                                    if (!selectedLineType) {
                                                                        setNotifyDialogTitle("Note!");
                                                                        setNotifyDialogText(`Please select line type`);
                                                                        setIsNotifyDialogOpen(true);
                                                                        return;
                                                                    }

                                                                    if (!selectedProduct) {
                                                                        setNotifyDialogTitle("Note!");
                                                                        setNotifyDialogText(`Please select product`);
                                                                        setIsNotifyDialogOpen(true);
                                                                        return;
                                                                    }

                                                                    if (!selectedSubClassCover) {
                                                                        setNotifyDialogTitle("Note!");
                                                                        setNotifyDialogText(`Please select cover`);
                                                                        setIsNotifyDialogOpen(true);
                                                                        return;
                                                                    }
                                                                    // console.log(`selectedTreaty: ${JSON.stringify(selectedTreaty, null, 2)}`);
                                                                    // console.log(`selectedLineType: ${JSON.stringify(selectedLineType, null, 2)}`);
                                                                    // console.log(`selectedProduct: ${JSON.stringify(selectedProduct, null, 2)}`);
                                                                    // console.log(`selectedSubClassCover: ${JSON.stringify(selectedSubClassCover, null, 2)}`);
                                                                    const res = await newRequest.post("/treatyCover/add", {
                                                                        cover_treaty_code: selectedTreaty?.treaty_code,
                                                                        cover_line_type: selectedLineType?.line_type,
                                                                        cover_treaty_fm: selectedTreaty?.treaty_fm,
                                                                        cover_treaty_to: selectedTreaty?.treaty_to,
                                                                        cover_channel_fm: "!",
                                                                        cover_channel_to: "~~~~~",
                                                                        cover_pr_code: selectedProduct?.pr_code,
                                                                        cover_mc_code: selectedProduct?.mc_code,
                                                                        cover_sc_code: selectedProduct?.sc_code,
                                                                        cover_cc_code: selectedSubClassCover?.cc_code,
                                                                        cover_limits: [],
                                                                    });

                                                                    if (res.data?.msg === "added") {
                                                                        setTreatyCovers((prev) => [...prev, res.data.doc]);
                                                                        setSelectedSubClassCover(null);
                                                                        if (coverRef.current) {
                                                                            coverRef.current.focus();
                                                                        }
                                                                        showToast(`Added`, "success");
                                                                    } else if (res.data?.msg === "exists") {
                                                                        setSelectedSubClassCover(null);
                                                                        if (coverRef.current) {
                                                                            coverRef.current.focus();
                                                                        }
                                                                        showToast(`Cover already added`, "success");
                                                                    } else {
                                                                        showToast(`Unable to add record`, "error");
                                                                    }
                                                                } catch (error) {
                                                                    console.log(error);
                                                                }
                                                            }}
                                                            icon={<MdAdd />}
                                                            width={"30px"}
                                                            height={"30px"} />
                                                    </span>
                                                </div>}
                                            <div className="table-content">
                                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                    <Table sx={{ width: "max-content", border: 'none' }}>
                                                        <TableHead className="tablehead">
                                                            <TableRow className="tablerow">
                                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                    <span>#</span>
                                                                </TableCell>
                                                                <TableCell className="table-cell" style={{ width: "auto", gap: "10px", alignItems: "center" }}>
                                                                    <span style={{ width: "10%" }}>{t('details').toUpperCase()}</span>
                                                                    <div className="search-input-wrapper" style={{ width: "90%" }}>
                                                                        <FiSearch className="search-input-icon" />
                                                                        <input
                                                                            className="search-input"
                                                                            type="text"
                                                                            height={"36px"}
                                                                            placeholder={`${t('search')} ${t('cover')}`}
                                                                            value={searchTermCover}
                                                                            onChange={(e) => setSearchTermCover(e.target.value)}
                                                                        />
                                                                        {searchTermCover.length > 0 && (
                                                                            <MdClose
                                                                                onClick={() => setSearchTermCover("")}
                                                                                className="search-input-icon"
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </TableCell>
                                                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }} />}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody className="tablebody">
                                                            {slicedCoversData?.map((row, index) => (
                                                                <TableRow
                                                                    key={row?._id}
                                                                    className={`${selectedTreatyCover?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                    onClick={() => {
                                                                        try {
                                                                            setSelectedTreatyCover(row)
                                                                            setTreatyCoverLimits([]);
                                                                            const formattedData = selectedTreatyCover?.cover_limits?.map(item => ({
                                                                                ...item,
                                                                                limit_si_fm: formatNumber(item.limit_si_fm),
                                                                                limit_si_to: formatNumber(item.limit_si_to),
                                                                                limit_retention: formatNumber(item.limit_retention),
                                                                                limit_lines: formatNumber(item.limit_lines, 0),
                                                                                limit_cqs_perc: formatNumber(item.limit_cqs_perc),
                                                                                limit_qs_perc: formatNumber(item.limit_qs_perc),
                                                                            }));
                                                                            setTreatyCoverLimits(formattedData);
                                                                            setSelectedCoverLimit(null);
                                                                            setSelectedCoverLimit(formattedData[0]);

                                                                            setQsParticipants(formattedData[0]?.limit_qs_participants);
                                                                            setCqsParticipants(formattedData[0]?.limit_cqs_participants);
                                                                            setSurplusParticipants(formattedData[0]?.limit_surplus_participants);

                                                                            // logData("qsPart", formattedData[0]?.limit_qs_participants);
                                                                            // logData("cqsPart", formattedData[0]?.limit_cqs_participants);
                                                                            // logData("surplusPart", formattedData[0]?.limit_surplus_participants);

                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }}
                                                                >
                                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                        <span>{coversPage * rowsPerPageCovers + index + 1}</span>
                                                                    </TableCell>
                                                                    <TableCell className="table-cell" style={{ maxWidth: "200px", gap: "5px" }}>
                                                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) ?
                                                                            <Select
                                                                                id={`cover_channel_fm_${row?._id}`}
                                                                                name={`cover_channel_fm_${row?._id}`}
                                                                                menuPortalTarget={document.body}
                                                                                styles={{
                                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                    menuPortal: base => ({
                                                                                        ...base,
                                                                                        zIndex: 9999,
                                                                                    })
                                                                                }}
                                                                                width="100%"
                                                                                height="36px"
                                                                                options={channelTypes}
                                                                                isSearchable={true}
                                                                                placeholder={t('from')}
                                                                                value={channelTypes.find(option => option.value === row?.cover_channel_fm) || null}
                                                                                onChange={selectedOption => handleCoverChange(row?._id, "cover_channel_fm", selectedOption)}
                                                                                isDisabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                            /> :
                                                                            <span>{channelTypes.find(option => option?.value === row?.cover_channel_fm)?.label || ""}</span>}
                                                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) ?
                                                                            <Select
                                                                                id={`cover_channel_to_${row?._id}`}
                                                                                name={`cover_channel_to_${row?._id}`}
                                                                                menuPortalTarget={document.body}
                                                                                styles={{
                                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                    menuPortal: base => ({
                                                                                        ...base,
                                                                                        zIndex: 9999,
                                                                                    })
                                                                                }}
                                                                                width="100%"
                                                                                height="36px"
                                                                                options={channelTypes}
                                                                                isSearchable={true}
                                                                                placeholder={t('to')}
                                                                                value={channelTypes.find(option => option.value === row?.cover_channel_to) || null}
                                                                                onChange={selectedOption => handleCoverChange(row?._id, "cover_channel_to", selectedOption)}
                                                                                isDisabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                            />
                                                                            :
                                                                            <span>{channelTypes.find(option => option?.value === row?.cover_channel_to)?.label || ""}</span>}
                                                                    </TableCell>
                                                                    <TableCell className="table-cell" style={{ width: "auto", flexDirection: "column", }}>
                                                                        <div style={{ display: "flex", width: "100%", padding: "0px 5px", flexDirection: "row", justifyContent: "space-between" }}>
                                                                            <div style={{ display: "flex", flex: "1", flexDirection: "column", alignItems: "flex-start" }}>
                                                                                <h1 className="sub-title">{`${t('product').toUpperCase()}: ${row?.cover_pr_code} - [${row?.cover_pr_code_xx}]`}</h1>
                                                                                <h1 className="sub-title">{`${t('class').toUpperCase()}: ${row?.cover_mc_code} - [${row?.cover_mc_code_xx}]`}</h1>
                                                                            </div>
                                                                            <div style={{ display: "flex", flex: "1", flexDirection: "column", alignItems: "flex-start" }}>
                                                                                <h1 className="sub-title">{`${t('subClass').toUpperCase()}: ${row?.cover_sc_code} - [${row?.cover_sc_code_xx}]`}</h1>
                                                                                <h1 className="sub-title">{`${t('cover').toUpperCase()}: ${row?.cover_cc_code} - [${row?.cover_cc_code_xx}]`}</h1>
                                                                            </div>
                                                                        </div>
                                                                        {selectedLineType?.line_type === "Retention" &&
                                                                            <div style={{ display: "flex", width: "100%", margin: "5px 0px", flexDirection: "row", justifyContent: "space-between" }}>
                                                                                <ToggleSwitch
                                                                                    value={row?.cover_fac_allocation}
                                                                                    onChange={(newValue) => handleFacAllocation(newValue, row?._id, "cover_fac_allocation")}
                                                                                    label={t('seekFac')}
                                                                                    labelPosition="end"
                                                                                    labelWidth="max-content"
                                                                                    border="N"
                                                                                    disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                />
                                                                            </div>}
                                                                    </TableCell>
                                                                    {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px", gap: "5px" }}>
                                                                            <CircularButton
                                                                                currentTheme={currentTheme}
                                                                                onClick={async () => {
                                                                                    try {
                                                                                        setSelectedTreatyCover(row);
                                                                                        await fetchRiskCategories(row?.cover_mc_code, row?.cover_sc_code, row?.cover_cc_code);
                                                                                        setTreatyCoverLimits([]);
                                                                                        const formattedData = row?.cover_limits?.map(item => ({
                                                                                            ...item,
                                                                                            limit_si_fm: formatNumber(item.limit_si_fm),
                                                                                            limit_si_to: formatNumber(item.limit_si_to),
                                                                                            limit_retention: formatNumber(item.limit_retention),
                                                                                            limit_lines: formatNumber(item.limit_lines, 0),
                                                                                            limit_cqs_perc: formatNumber(item.limit_cqs_perc),
                                                                                            limit_qs_perc: formatNumber(item.limit_qs_perc),
                                                                                        }));
                                                                                        setTreatyCoverLimits(formattedData);
                                                                                        setSelectedCoverLimit(null);
                                                                                        setSelectedCoverLimit(formattedData[0]);

                                                                                        if (row?.cover_limits[0]?.limit_qs_participants &&
                                                                                            Array.isArray(row?.cover_limits[0]?.limit_qs_participants)) {
                                                                                            setQsParticipants(row?.cover_limits[0]?.limit_qs_participants);
                                                                                        } else {
                                                                                            setQsParticipants([]);
                                                                                        }
                                                                                        if (row?.cover_limits[0]?.limit_cqs_participants &&
                                                                                            Array.isArray(row?.cover_limits[0]?.limit_cqs_participants)) {
                                                                                            setCqsParticipants(row?.cover_limits[0]?.limit_cqs_participants);
                                                                                        } else {
                                                                                            setCqsParticipants([]);
                                                                                        }
                                                                                        if (row?.cover_limits[0]?.limit_surplus_participants &&
                                                                                            Array.isArray(row?.cover_limits[0]?.limit_surplus_participants)) {
                                                                                            setSurplusParticipants(row?.cover_limits[0]?.limit_surplus_participants);
                                                                                        } else {
                                                                                            setSurplusParticipants([]);
                                                                                        }
                                                                                        setCurrentView("limits");
                                                                                    } catch (error) {
                                                                                        console.log(error);
                                                                                    }
                                                                                }} icon={<LuListVideo color="green" />} width={"30px"} height={"30px"} />
                                                                            {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                                                <CircularButton
                                                                                    currentTheme={currentTheme}
                                                                                    color="#E53935"
                                                                                    onClick={async () => {
                                                                                        try {
                                                                                            setObjectToAction({ object_id: row._id });
                                                                                            setConfirmationActiontext(`Do you want to REMOVE ${`${t('cover').toUpperCase()}: ${row?.cover_cc_code} - [${row?.cover_cc_code_xx}]`} from this treaty?<br/><br/>Please note this action is irrevasible`);
                                                                                            setConfirmDialogAction("deleteTreatyCover");
                                                                                            setIsConfirmDialogOpen(true);
                                                                                        } catch (error) {
                                                                                            console.log(error);
                                                                                        }
                                                                                    }}
                                                                                    icon={<MdDelete />}
                                                                                    width={"30px"}
                                                                                    height={"30px"} />}
                                                                        </TableCell>}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                    {treatyCovers.length > rowsPerPageCovers &&
                                                        <TablePagination
                                                            rowsPerPageOptions={[4]}
                                                            rowsPerPage={rowsPerPageCovers}
                                                            onRowsPerPageChange={handleCoversChangeRowsPerPage}
                                                            component="div"
                                                            count={treatyCovers.length}
                                                            page={coversPage}
                                                            onPageChange={handleCoversChangePage}
                                                        />}
                                                </TableContainer>
                                            </div>
                                        </div>
                                    </div>}
                                {currentView === "limits" &&
                                    <div className="line-limits-view">
                                        <div className="line-limits-view-navbar">
                                            <div className="line-limits-view-left">
                                                <div className="item-value">
                                                    <span className="label">{t('product').toUpperCase()}</span>
                                                    <span className="value">{`${selectedTreatyCover?.cover_pr_code_xx} [${selectedTreatyCover?.cover_pr_code}]`}</span>
                                                </div>
                                                <div className="item-value">
                                                    <span className="label">{t('class').toUpperCase()}</span>
                                                    <span className="value">{`${selectedTreatyCover?.cover_mc_code_xx} [${selectedTreatyCover?.cover_mc_code}]`}</span>
                                                </div>
                                            </div>
                                            <div className="line-limits-view-left">
                                                <div className="item-value">
                                                    <span className="label">{t('subClass').toUpperCase()}</span>
                                                    <span className="value">{`${selectedTreatyCover?.cover_sc_code_xx} [${selectedTreatyCover?.cover_sc_code}]`}</span>
                                                </div>

                                                <div className="item-value">
                                                    <span className="label">{t('cover').toUpperCase()}</span>
                                                    <span className="value">{`${selectedTreatyCover?.cover_cc_code_xx} [${selectedTreatyCover?.cover_cc_code}]`}</span>
                                                </div>

                                            </div>
                                            <div className="line-limits-view-right">
                                                {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                    <CircularButton
                                                        currentTheme={currentTheme}
                                                        onClick={async () => {
                                                            try {
                                                                const res = await newRequest.post("/treatyCover/addCoverLimit", { cover_docid: selectedTreatyCover?._id });
                                                                if (res.data.msg === "added") {
                                                                    setTreatyCoverLimits((prev) => [...prev, res.data.doc]);
                                                                    showToast(t('added'), "success");
                                                                } else if (res.data.msg === "exists") {
                                                                    showToast(`Cover already added`, "success");
                                                                } else {
                                                                    showToast(`Unable to add record`, "error");
                                                                }
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        color="#2E7D32"
                                                        icon={<MdAdd />}
                                                        width={"30px"}
                                                        height={"30px"} />}
                                                <hr className="separator-v" />
                                                <CircularButton
                                                    currentTheme={currentTheme}
                                                    onClick={() => setCurrentView("covers")}
                                                    icon={<IoArrowBackSharp color="blue" />} width={"30px"} height={"30px"} />
                                            </div>
                                        </div>
                                        <div className="table-content">
                                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                                <Table sx={{ width: "max-content", border: 'none' }}>
                                                    <TableHead className="tablehead">
                                                        <TableRow className="tablerow">
                                                            <TableCell className="table-cell center" style={{ maxWidth: "30px" }}>
                                                                <span>#</span>
                                                            </TableCell>
                                                            <TableCell className="table-cell left" style={{ maxWidth: "160px" }}>
                                                                <span>{t('catg').toUpperCase()}</span>
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ width: "auto" }} >
                                                                <span>{t('siRange').toUpperCase()}</span>
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "200px", gap: "3px" }}>
                                                                <span>{`${t('retention').toUpperCase()} [${selectedTreaty?.treaty_currency}]`}</span>
                                                            </TableCell>
                                                            <TableCell className="table-cell right" style={{ maxWidth: "170px" }} >
                                                                <span>{`${t('capacity').toUpperCase()} [${selectedTreaty?.treaty_currency}]`}</span>
                                                            </TableCell>
                                                            {selectedLineType?.line_type === "Retention" &&
                                                                <TableCell className="table-cell center" style={{ maxWidth: "200px" }} >
                                                                    <span>{t('qsCqs').toUpperCase()}</span>
                                                                </TableCell>}
                                                            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }} />}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody className="tablebody">
                                                        {treatyCoverLimits?.length > 0 &&
                                                            <>
                                                                {treatyCoverLimits?.map((row, index) => (
                                                                    <TableRow
                                                                        key={row?._id}
                                                                        className={`${selectedCoverLimit?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                        onClick={() => {
                                                                            try {
                                                                                setSelectedCoverLimit(row);

                                                                                if (row?.limit_qs_participants &&
                                                                                    Array.isArray(row?.limit_qs_participants)) {
                                                                                    setQsParticipants(row?.limit_qs_participants);
                                                                                } else {
                                                                                    setQsParticipants([]);
                                                                                }

                                                                                if (row?.limit_cqs_participants &&
                                                                                    Array.isArray(row?.limit_cqs_participants)) {
                                                                                    setCqsParticipants(row?.limit_cqs_participants);
                                                                                } else {
                                                                                    setCqsParticipants([]);
                                                                                }
                                                                                if (row?.limit_surplus_participants &&
                                                                                    Array.isArray(row?.limit_surplus_participants)) {
                                                                                    setSurplusParticipants(row?.limit_surplus_participants);
                                                                                } else {
                                                                                    setSurplusParticipants([]);
                                                                                }
                                                                            } catch (error) {
                                                                                console.log(error);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <TableCell className="table-cell center" style={{ maxWidth: "30px" }}>
                                                                            <span>{coversPage * rowsPerPageCovers + index + 1}</span>
                                                                        </TableCell>
                                                                        <TableCell className="table-cell left" style={{ maxWidth: "160px", gap: "3px" }}>
                                                                            <Select
                                                                                id={`limit_catg_fm_${row?._id}`}
                                                                                name={`limit_catg_fm_${row?._id}`}
                                                                                menuPortalTarget={document.body}
                                                                                styles={{
                                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                    menuPortal: base => ({
                                                                                        ...base,
                                                                                        zIndex: 9999,
                                                                                    })
                                                                                }}
                                                                                width="100%"
                                                                                height="36px"
                                                                                options={riskCategories}
                                                                                isSearchable={true}
                                                                                placeholder={t('from')}
                                                                                value={riskCategories.find(option => option.value === row?.limit_catg_fm) || null}
                                                                                onChange={selectedOption => handleCoverLimitsChange(row?._id, "limit_catg_fm", selectedOption)}
                                                                                isDisabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                            />
                                                                            <Select
                                                                                id={`limit_catg_to_${row?._id}`}
                                                                                name={`limit_catg_to_${row?._id}`}
                                                                                menuPortalTarget={document.body}
                                                                                styles={{
                                                                                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                                    menuPortal: base => ({
                                                                                        ...base,
                                                                                        zIndex: 9999,
                                                                                    })
                                                                                }}
                                                                                width="100%"
                                                                                height="36px"
                                                                                options={riskCategories}
                                                                                isSearchable={true}
                                                                                placeholder={t('to')}
                                                                                value={riskCategories.find(option => option.value === row?.limit_catg_to) || null}
                                                                                onChange={selectedOption => handleCoverLimitsChange(row?._id, "limit_catg_to", selectedOption)}
                                                                                isDisabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell className="table-cell" style={{ width: "auto", gap: "3px" }}>
                                                                            {["admin", "superadmin"].includes(currentUser.user_type_xx) ?
                                                                                <div className="input-item-with-label">
                                                                                    <input
                                                                                        id="limit_si_fm"
                                                                                        name="limit_si_fm"
                                                                                        type="text"
                                                                                        value={row?.limit_si_fm}
                                                                                        onChange={(e) => handleCoverInputsChange(e, row?._id)}
                                                                                        style={{ width: "100%", textAlign: "right" }}
                                                                                        className="form-input-item table"
                                                                                        onBlur={() => {
                                                                                            handleCoverLimitsBlur(row?._id, "limit_si_fm");
                                                                                        }}
                                                                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                    />
                                                                                </div> :
                                                                                <span>{row?.limit_si_fm || 0}</span>}
                                                                            {["admin", "superadmin"].includes(currentUser.user_type_xx) ?
                                                                                <div className="input-item-with-label">
                                                                                    <input
                                                                                        id="limit_si_to"
                                                                                        name="limit_si_to"
                                                                                        type="text"
                                                                                        value={row?.limit_si_to}
                                                                                        onChange={(e) => handleCoverInputsChange(e, row._id)}
                                                                                        style={{ width: "100%", textAlign: "right" }}
                                                                                        className="form-input-item table"
                                                                                        onBlur={() => {
                                                                                            handleCoverLimitsBlur(row?._id, "limit_si_to");
                                                                                        }}
                                                                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <span>{row?.limit_si_to || 0}</span>}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "200px", gap: "3px" }}>
                                                                            {["admin", "superadmin"].includes(currentUser.user_type_xx) ?
                                                                                <div className="input-item-with-label">
                                                                                    <input
                                                                                        id="limit_retention"
                                                                                        name="limit_retention"
                                                                                        type="text"
                                                                                        value={row?.limit_retention}
                                                                                        onChange={(e) => handleCoverInputsChange(e, row._id)}
                                                                                        style={{ width: "100%", textAlign: "right" }}
                                                                                        className="form-input-item table"
                                                                                        onBlur={() => {
                                                                                            handleCoverLimitsBlur(row?._id, "limit_retention");
                                                                                        }}
                                                                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                    />
                                                                                </div> :
                                                                                <span>{row?.limit_retention || 0}</span>}
                                                                            {["admin", "superadmin"].includes(currentUser.user_type_xx) ?
                                                                                <div className="input-item-with-label" style={{ justifyContent: "flex-end" }}>
                                                                                    <label htmlFor="limit_lines"  >
                                                                                        {t('noOfLines').toUpperCase()}
                                                                                    </label>
                                                                                    <input
                                                                                        id="limit_lines"
                                                                                        name="limit_lines"
                                                                                        type="number"
                                                                                        value={row?.limit_lines}
                                                                                        onChange={(e) => handleCoverInputsChange(e, row._id)}
                                                                                        style={{ width: "40%", textAlign: "right" }}
                                                                                        className="form-input-item table"
                                                                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                    />
                                                                                </div>
                                                                                :
                                                                                <span>{row?.limit_lines || 0}</span>}
                                                                        </TableCell>
                                                                        <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                                                                            <span className="sub-title">{formatNumber(formatStringToNumberV2(row?.limit_retention || 0) * formatStringToNumberV2(row?.limit_lines || 0) || 0)}</span>
                                                                        </TableCell>
                                                                        {selectedLineType?.line_type === "Retention" &&
                                                                            <TableCell className="table-cell left" style={{ maxWidth: "200px", gap: "3px" }} >
                                                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", gap: "5px", justifyContent: "space-between" }}>
                                                                                    <ToggleSwitch
                                                                                        id={`${row?._id}_limit_cqs`}
                                                                                        value={row.limit_cqs}
                                                                                        onChange={(newValue) => {
                                                                                            try {
                                                                                                handleCoverLimitsCqsQs(newValue, row?._id, "limit_cqs");
                                                                                                if (newValue === "N") {
                                                                                                    handleCoverLimitsCqsQs(0, row?._id, "limit_cqs_perc");
                                                                                                }
                                                                                            } catch (error) {
                                                                                                console.log(error);
                                                                                            }
                                                                                        }}
                                                                                        label={t('cqs').toUpperCase()}
                                                                                        labelPosition="end"
                                                                                        labelWidth="max-content"
                                                                                        border="N"
                                                                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                    />
                                                                                    <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                                                                                        <input
                                                                                            id="limit_cqs_perc"
                                                                                            name="limit_cqs_perc"
                                                                                            type="number"
                                                                                            value={row?.limit_cqs_perc}
                                                                                            onChange={(e) => handleCoverInputsChange(e, row._id)}
                                                                                            style={{ width: "60px", textAlign: "right" }}
                                                                                            className="form-input-item table"
                                                                                            onBlur={() => { handleCoverLimitsBlur(row?._id, "limit_cqs_perc"); }}
                                                                                            disabled={(row.limit_cqs === "N" || ["Approved", "Suspended"].includes(selectedTreaty?.treaty_status))}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", gap: "5px", justifyContent: "space-between" }}>
                                                                                    <ToggleSwitch
                                                                                        id={`${row?._id}_limit_qs`}
                                                                                        value={row.limit_qs}
                                                                                        onChange={(newValue) => {
                                                                                            try {
                                                                                                handleCoverLimitsCqsQs(newValue, row?._id, "limit_qs");
                                                                                                if (newValue === "N") {
                                                                                                    handleCoverLimitsCqsQs(0, row?._id, "limit_qs_perc");
                                                                                                }
                                                                                            } catch (error) {
                                                                                                console.log(error);
                                                                                            }
                                                                                        }}
                                                                                        label={t('qs').toUpperCase()}
                                                                                        labelPosition="end"
                                                                                        labelWidth="max-content"
                                                                                        border="N"
                                                                                        disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                    />
                                                                                    <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                                                                                        <input
                                                                                            id="limit_qs_perc"
                                                                                            name="limit_qs_perc"
                                                                                            type="number"
                                                                                            value={row?.limit_qs_perc}
                                                                                            onChange={(e) => handleCoverInputsChange(e, row._id)}
                                                                                            style={{ width: "60px", textAlign: "right" }}
                                                                                            className="form-input-item table"
                                                                                            onBlur={() => { handleCoverLimitsBlur(row?._id, "limit_qs_perc"); }}
                                                                                            disabled={(row.limit_qs === "N" || ["Approved", "Suspended"].includes(selectedTreaty?.treaty_status))}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </TableCell>}
                                                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                                                            <TableCell className="table-cell center" style={{ maxWidth: "50px", gap: "5px" }}>
                                                                                {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                                                    <CircularButton
                                                                                        currentTheme={currentTheme}
                                                                                        color="#E53935"
                                                                                        onClick={async () => {
                                                                                            try {
                                                                                                setObjectToAction({ object_id: row._id });
                                                                                                setConfirmationActiontext(`Do you want to REMOVE this line with capacity 
                                                                                                    ${formatNumber(formatStringToNumberV2(row?.limit_retention || 0) * formatStringToNumberV2(row?.limit_lines || 0) || 0)} 
                                                                                                    ?<br/><br/>Please note this action is irrevasible`);
                                                                                                setConfirmDialogAction("deleteTreatyLimit");
                                                                                                setIsConfirmDialogOpen(true);
                                                                                            } catch (error) {
                                                                                                console.log(error);
                                                                                            }
                                                                                        }}
                                                                                        icon={<MdDelete />}
                                                                                        width={"30px"}
                                                                                        height={"30px"} />}
                                                                            </TableCell>}
                                                                    </TableRow>
                                                                ))}
                                                            </>
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                        {(selectedLineType?.line_type === "Retention" &&
                                            (selectedCoverLimit?.limit_qs === "Y" ||
                                                selectedCoverLimit?.limit_cqs === "Y")
                                            ||
                                            (selectedLineType?.line_type !== "Retention")) &&
                                            <motion.div
                                                className="participants"
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1, transition: { duration: 1 } }}
                                                exit={{ opacity: 0, transition: { duration: 1 } }}>
                                                <hr className="separator-h" />
                                                <div className="participants-wrapper">
                                                    {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                        <div className="participants-navbar">
                                                            {selectedLineType?.line_type !== "Retention" &&
                                                                <span className="main-title">{t('surplusParticipants')} {`${totalSurplus} %`}</span>}
                                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                                                                <AsyncSelect
                                                                    ref={participantRef}
                                                                    id="surplus_participant"
                                                                    name="surplus_participant"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        })
                                                                    }}
                                                                    width="300px"
                                                                    value={selectedParticipant}
                                                                    onChange={(selectedOption) => setSelectedParticipant(selectedOption)}
                                                                    loadOptions={(inputValue, callback) => fetchClientsBySearch(inputValue, callback, ["Corporate"])}
                                                                    isSearchable={true}
                                                                    placeholder={t('participant')}
                                                                    noOptionsMessage={() => "Type Minimum 3 Letter to Search"}
                                                                />
                                                                {selectedLineType?.line_type === "Retention" &&
                                                                    (selectedCoverLimit?.limit_qs === "Y" ||
                                                                        selectedCoverLimit?.limit_cqs === "Y") &&
                                                                    <Select
                                                                        id="selectedPartType"
                                                                        name="selectedPartType"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                                            menuPortal: base => ({
                                                                                ...base,
                                                                                zIndex: 9999,
                                                                            })
                                                                        }}
                                                                        width="100px"
                                                                        value={selectedPartType}
                                                                        onChange={(selectedOption) => setSelectedPartType(selectedOption)}
                                                                        options={partTypes}
                                                                        placeholder={t('type').toUpperCase()}
                                                                    />}
                                                                <div className="input-item-with-label">
                                                                    <input
                                                                        id="participant_perc"
                                                                        name="participant_perc"
                                                                        type="number"
                                                                        placeholder="%"
                                                                        value={participantPerc}
                                                                        className="form-input-item"
                                                                        style={{ width: "80px", textAlign: "right" }}
                                                                        min="1"
                                                                        max="100"
                                                                        onChange={(e) => {
                                                                            const value = parseInt(e.target.value, 10);
                                                                            if (value < 1 || value > 100) {
                                                                                e.target.value = participantPerc;
                                                                                setNotifyDialogTitle("Note!");
                                                                                setNotifyDialogText(`Please ener value <b>between 1 and 100</b>.`);
                                                                                setIsNotifyDialogOpen(true);
                                                                            } else {
                                                                                setParticipantPerc(value);
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                                <CircularButton currentTheme={currentTheme}
                                                                    onClick={async () => {
                                                                        try {
                                                                            await addParticipant();
                                                                        } catch (e) {
                                                                            console.log(e);
                                                                        }
                                                                    }}
                                                                    icon={<MdAdd />}
                                                                    width={"30px"}
                                                                    height={"30px"} />
                                                            </span>
                                                        </div>}
                                                    {/* SURPLUS PARTICIPANTS */}
                                                    <div className="participants-content">
                                                        {surplusParticipants?.length > 0 &&
                                                            <div className="participants-wrapper">
                                                                {surplusParticipants?.map((surplus) => (
                                                                    <div key={surplus?._id}
                                                                        className={`${surplus?._id === selectedParticipant?.docid ? "single-participant current" : "single-participant"}`}
                                                                        onClick={() => {
                                                                            setSelectedParticipant({
                                                                                code: surplus?.surplus_ent_code,
                                                                                name: surplus?.surplus_ent_code_xx,
                                                                                docid: surplus?._id,
                                                                                rate: formatNumber(surplus?.surplus_rate, 6),
                                                                                destination: "surplus"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <div className="single-participant-left">
                                                                            {surplus?.surplus_photo_url ?
                                                                                <img src={surplus?.surplus_photo_url} alt="" className="img" /> :
                                                                                <InitialsAvatar
                                                                                    name={surplus?.surplus_ent_code_xx}
                                                                                    size={45}
                                                                                    currentTheme={currentTheme}
                                                                                />
                                                                            }
                                                                        </div>
                                                                        <div className="single-participant-right">
                                                                            <div className="single-participant-header">
                                                                                <span className='participant-name'>{surplus?.surplus_ent_code_xx}</span>
                                                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                                                    <CircularButton
                                                                                        currentTheme={currentTheme}
                                                                                        onClick={() => {
                                                                                            try {
                                                                                                setParticipantCharges(surplus?.surplus_charges || []);
                                                                                                setSelectedParticipant({
                                                                                                    code: surplus?.surplus_ent_code,
                                                                                                    name: surplus?.surplus_ent_code_xx,
                                                                                                    docid: surplus?._id,
                                                                                                    rate: formatNumber(surplus?.surplus_rate, 6),
                                                                                                    destination: "surplus"
                                                                                                });
                                                                                                setChargesDialogOpen(true);
                                                                                            } catch (error) {
                                                                                                console.log(error);
                                                                                            }
                                                                                        }} icon={<MdEdit color="blue" />} width={"30px"} height={"30px"} />
                                                                                    {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                                                        <CircularButton
                                                                                            currentTheme={currentTheme}
                                                                                            onClick={async (e) => {
                                                                                                try {
                                                                                                    if (!selectedTreatyCover?._id) {
                                                                                                        showToast("Select cover", "error");
                                                                                                        return;
                                                                                                    }
                                                                                                    if (!selectedCoverLimit?._id) {
                                                                                                        showToast("Select limit", "error");
                                                                                                        return;
                                                                                                    }
                                                                                                    if (!surplus?._id) {
                                                                                                        showToast("Participant document id not found", "error");
                                                                                                        return;
                                                                                                    }

                                                                                                    // console.log(`url ... ${url}`);
                                                                                                    const res = await newRequest.post("/treatyCover/delSurplusPart", {
                                                                                                        cover_docid: selectedTreatyCover?._id,
                                                                                                        limit_docid: selectedCoverLimit?._id,
                                                                                                        participant_id: surplus?._id
                                                                                                    });
                                                                                                    if (res.data?.msg === "deleted") {
                                                                                                        setSurplusParticipants((prev) => prev.filter(line => line?._id !== surplus?._id));
                                                                                                        showToast(t('deleted'), "success");
                                                                                                    } else {
                                                                                                        showToast("Error removing!", "error");
                                                                                                    }
                                                                                                } catch (error) {
                                                                                                    console.log(error);
                                                                                                }
                                                                                            }} icon={<MdDelete />} width={"30px"} height={"30px"} />}
                                                                                </div>
                                                                            </div>
                                                                            <div className="participant-phone-row">
                                                                                <span className="participant-phone-details" style={{ flex: "3" }}><MdAlternateEmail className="icon" />{surplus?.surplus_ent_email}</span>
                                                                                <span className="participant-phone-details"
                                                                                    style={{ flex: "1" }}>
                                                                                    <MdNumbers className="icon" />{surplus?.surplus_ent_code}</span>
                                                                                <span className="percentage">{`${surplus?.surplus_rate} %`}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>}
                                                    </div>
                                                    {selectedLineType?.line_type === "Retention" &&
                                                        selectedCoverLimit?.limit_qs === "Y" &&
                                                        <span className="main-title">{t('qsParticipants')} {`${totalQs} %`}</span>}
                                                    {Array.isArray(qsParticipants) &&
                                                        selectedCoverLimit?.limit_qs === "Y" &&
                                                        <div className="participants-content">
                                                            {qsParticipants?.length > 0 &&
                                                                <div className="participants-wrapper">
                                                                    {qsParticipants?.map((qs) => (
                                                                        <div key={qs?._id}
                                                                            className={`${qs?._id === selectedParticipant?.docid ? "single-participant current" : "single-participant"}`}
                                                                            onClick={() => {
                                                                                setSelectedParticipant({
                                                                                    code: qs?.qs_ent_code,
                                                                                    name: qs?.qs_ent_code_xx,
                                                                                    docid: qs?._id,
                                                                                    rate: formatNumber(qs?.qs_rate, 6),
                                                                                    destination: "qs"
                                                                                })
                                                                            }} >
                                                                            <div className="single-participant-left">
                                                                                {qs?.qs_photo_url ?
                                                                                    <img src={qs?.qs_photo_url} alt="" className="img" /> :
                                                                                    <InitialsAvatar
                                                                                        name={qs?.qs_ent_code_xx}
                                                                                        size={45}
                                                                                        currentTheme={currentTheme}
                                                                                    />
                                                                                }
                                                                            </div>
                                                                            <div className="single-participant-right">
                                                                                <div className="single-participant-header">
                                                                                    <span className='participant-name'>{qs?.qs_ent_code_xx}</span>
                                                                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                                                        <CircularButton
                                                                                            currentTheme={currentTheme}
                                                                                            aria-describedby={id}
                                                                                            onClick={(e) => {
                                                                                                try {
                                                                                                    console.log((`docid ${qs?._id}`));
                                                                                                    setParticipantCharges(qs?.qs_charges || []);
                                                                                                    setSelectedParticipant({
                                                                                                        code: qs?.qs_ent_code,
                                                                                                        name: qs?.qs_ent_code_xx,
                                                                                                        docid: qs?._id,
                                                                                                        rate: formatNumber(qs?.qs_rate, 6),
                                                                                                        destination: "qs"
                                                                                                    });
                                                                                                    setChargesDialogOpen(true);
                                                                                                } catch (error) {
                                                                                                    console.log(error);
                                                                                                }
                                                                                            }} icon={<MdEdit color="blue" />} width={"30px"} height={"30px"} />
                                                                                        {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                                                            <CircularButton
                                                                                                currentTheme={currentTheme}
                                                                                                onClick={async (e) => {
                                                                                                    try {
                                                                                                        if (!selectedTreatyCover?._id) {
                                                                                                            showToast("Select cover", "error");
                                                                                                            return;
                                                                                                        }
                                                                                                        if (!selectedCoverLimit?._id) {
                                                                                                            showToast("Select limit", "error");
                                                                                                            return;
                                                                                                        }
                                                                                                        if (!qs?._id) {
                                                                                                            showToast("Participant document id not found", "error");
                                                                                                            return;
                                                                                                        }

                                                                                                        // console.log(`url ... ${url}`);
                                                                                                        const res = await newRequest.post("/treatyCover/delQsPart", {
                                                                                                            cover_docid: selectedTreatyCover?._id,
                                                                                                            limit_docid: selectedCoverLimit?._id,
                                                                                                            participant_id: qs?._id
                                                                                                        });
                                                                                                        if (res.data?.msg === "deleted") {
                                                                                                            setQsParticipants((prev) => prev.filter(line => line?._id !== qs?._id));
                                                                                                            showToast(t('deleted'), "success");
                                                                                                        } else {
                                                                                                            showToast("Error removing!", "error");
                                                                                                        }
                                                                                                    } catch (error) {
                                                                                                        console.log(error);
                                                                                                    }
                                                                                                }} icon={<MdDelete />} width={"30px"} height={"30px"} />}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="participant-phone-row">
                                                                                    <span className="participant-phone-details" style={{ flex: "3" }}>
                                                                                        <MdAlternateEmail className="icon" />{qs?.qs_ent_email}
                                                                                    </span>
                                                                                    <span className="participant-phone-details" style={{ flex: "1" }} >
                                                                                        <MdNumbers className="icon" />{qs?.qs_ent_code}</span>
                                                                                    <span className="percentage">{`${qs?.qs_rate} %`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>}
                                                        </div>}
                                                    <span className="separator-h" />
                                                    {selectedLineType?.line_type === "Retention" &&
                                                        selectedCoverLimit?.limit_cqs === "Y" &&
                                                        <span className="main-title">{t('cqsParticipants')} {`${totalCqs} %`}</span>}
                                                    {Array.isArray(cqsParticipants) &&
                                                        selectedCoverLimit?.limit_cqs === "Y" &&
                                                        <div className="participants-content">
                                                            {cqsParticipants?.length > 0 &&
                                                                <div className="participants-wrapper">
                                                                    {cqsParticipants?.map((cqs) => (
                                                                        <div key={cqs?._id}
                                                                            className={`${cqs?._id === selectedParticipant?.docid ? "single-participant current" : "single-participant"}`}
                                                                            onClick={() => {
                                                                                setSelectedParticipant({
                                                                                    code: cqs?.cqs_ent_code,
                                                                                    name: cqs?.cqs_ent_code_xx,
                                                                                    docid: cqs?._id,
                                                                                    rate: formatNumber(cqs?.cqs_rate, 6),
                                                                                    destination: "cqs"
                                                                                })
                                                                            }} >
                                                                            <div className="single-participant-left">
                                                                                {cqs?.cqs_photo_url ?
                                                                                    <img src={cqs?.qs_photo_url} alt="" className="img" /> :
                                                                                    <InitialsAvatar
                                                                                        name={cqs?.cqs_ent_code_xx}
                                                                                        size={45}
                                                                                        currentTheme={currentTheme}
                                                                                    />
                                                                                }
                                                                            </div>
                                                                            <div className="single-participant-right">
                                                                                <div className="single-participant-header">
                                                                                    <span className='participant-name'>{cqs?.cqs_ent_code_xx}</span>
                                                                                    <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                                                                        <CircularButton
                                                                                            currentTheme={currentTheme}
                                                                                            onClick={(e) => {
                                                                                                try {
                                                                                                    setParticipantCharges(cqs?.cqs_charges || []);
                                                                                                    setSelectedParticipant({
                                                                                                        code: cqs?.cqs_ent_code,
                                                                                                        name: cqs?.cqs_ent_code_xx,
                                                                                                        docid: cqs?._id,
                                                                                                        rate: formatNumber(cqs?.cqs_rate, 6),
                                                                                                        destination: "cqs"
                                                                                                    });
                                                                                                    setChargesDialogOpen(true);
                                                                                                } catch (error) {
                                                                                                    console.log(error);
                                                                                                }
                                                                                            }} icon={<MdEdit color="blue" />} width={"30px"} height={"30px"} />
                                                                                        {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                                                            <CircularButton
                                                                                                currentTheme={currentTheme}
                                                                                                onClick={async (e) => {
                                                                                                    try {
                                                                                                        if (!selectedTreatyCover?._id) {
                                                                                                            showToast("Select cover", "error");
                                                                                                            return;
                                                                                                        }
                                                                                                        if (!selectedCoverLimit?._id) {
                                                                                                            showToast("Select limit", "error");
                                                                                                            return;
                                                                                                        }
                                                                                                        if (!cqs?._id) {
                                                                                                            showToast("Participant document id not found", "error");
                                                                                                            return;
                                                                                                        }

                                                                                                        // console.log(`url ... ${url}`);
                                                                                                        const res = await newRequest.post("/treatyCover/delCqsPart", {
                                                                                                            cover_docid: selectedTreatyCover?._id,
                                                                                                            limit_docid: selectedCoverLimit?._id,
                                                                                                            participant_id: cqs?._id
                                                                                                        });
                                                                                                        if (res.data?.msg === "deleted") {
                                                                                                            setCqsParticipants((prev) => prev.filter(line => line?._id !== cqs?._id));
                                                                                                            showToast(t('deleted'), "success");
                                                                                                        } else {
                                                                                                            showToast("Error removing!", "error");
                                                                                                        }
                                                                                                    } catch (error) {
                                                                                                        console.log(error);
                                                                                                    }
                                                                                                }} icon={<MdDelete />} width={"30px"} height={"30px"} />}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="participant-phone-row">
                                                                                    <span className="participant-phone-details" style={{ flex: "3" }}>
                                                                                        <MdAlternateEmail className="icon" />{cqs?.cqs_ent_email}
                                                                                    </span>
                                                                                    <span className="participant-phone-details" style={{ flex: "1" }} >
                                                                                        <MdNumbers className="icon" />{cqs?.cqs_ent_code}</span>
                                                                                    <span className="percentage">{`${cqs?.cqs_rate} %`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>}
                                                        </div>}

                                                </div>
                                            </motion.div>}
                                    </div>}
                            </ExpandableComponent>
                        </div>
                    </div>
                    <div className="ri-treaty-right-wrapper">
                        <div className="homeSearch">
                            <FiSearch className="homeSearchIcon" />
                            <input
                                className="homeSearchInput"
                                type="text"
                                placeholder={`${t('search')} ${t('treaty')}`}
                                value={searchTermTreaty}
                                onChange={(e) => setSearchTermTreaty(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') handleSearchTreaties();
                                }}
                            />
                            {searchTermTreaty?.length > 0 && (
                                <MdClose
                                    className="homeSearchClear"
                                    onClick={async () => {
                                        try {
                                            await fetchTreaties();
                                            setSearchTermTreaty("");
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                />
                            )}
                        </div>
                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                width="150px"
                                color="#0ea5a4"
                                tooltip={"Add new treaty"}
                                endIcon={<IoAdd />}
                                onClick={() => {
                                    try {

                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}
                            >
                                {t('addTreaty')}
                            </CustomLoadingButton>}
                        <div className="treaties-list">
                            {treaties
                                ?.filter(
                                    (row) =>
                                        row?.treaty_code?.toLowerCase().includes(searchTermTreaty?.toLowerCase()) ||
                                        row?.treaty_name?.toLowerCase().includes(searchTermTreaty?.toLowerCase())
                                )
                                .map((row) => (
                                    <span
                                        key={row?._id}
                                        className={`${selectedTreaty?._id === row?._id
                                            ? "single-treaty active"
                                            : "single-treaty"
                                            }`}
                                        onClick={async () => {
                                            try {
                                                setSelectedTreaty({
                                                    ...row,
                                                    treaty_fm: moment(row?.treaty_fm).format("YYYY-MM-DD"),
                                                    treaty_to: moment(row?.treaty_to).format("YYYY-MM-DD")
                                                });
                                                setTreatyLines([]);
                                                setTreatyLines(row?.treaty_lines);
                                                setSelectedLineType(row?.treaty_lines[0]);
                                                setCoversPage(0);
                                                await fetchTreatyCovers(row?.treaty_code, row?.treaty_lines[0]?.line_type);
                                                setCurrentView("covers");
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        <h1 className="sub-title">{row?.treaty_name}</h1>
                                        <h1 className="sub-title xrsmall soft">{row?.treaty_code}</h1>
                                    </span>
                                ))}
                        </div>
                    </div>
                </motion.div>)}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle={t("confirmation")}
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={["ri-treaties"]}
                                documentData={{
                                    docNo: selectedTreaty?.treaty_code,
                                    docType: "Treaty",
                                    docId: selectedTreaty?._id,
                                }} />
                        </div>
                    </div>
                </motion.div>
            )}
            {chargesDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper" style={{ minWidth: "500px" }}>
                        <div className="overlay-navbar">
                            <span style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                <span className="charges-title-wrap">{selectedParticipant?.name}</span>
                                <span className="charges-title-wrap small">{`${selectedParticipant?.destination?.toUpperCase()} ${t('charges').toUpperCase()}`}</span>
                            </span>
                            <CircularButton currentTheme={currentTheme} onClick={() => setChargesDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                    <div className="input-item-with-label">
                                        <label htmlFor="treaty_name"
                                            className="form-input-label"
                                            style={{ width: "100px" }}>
                                            {t('charge').toUpperCase()}
                                        </label>
                                        <Select
                                            id="part_charge"
                                            name="part_charge"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                })
                                            }}
                                            width="350px"
                                            value={selectedDefinedCharge}
                                            onChange={(selectedOption) => setSelectedDefinedCharge(selectedOption)}
                                            options={definedCharges}
                                            isSearchable={true}
                                            placeholder={t('charge').toUpperCase()}
                                        />
                                        <span style={{ width: "3px" }} />
                                        <input
                                            id="definedChargeRate"
                                            name="definedChargeRate"
                                            type="text"
                                            value={selectedDefinedChargeRate}
                                            onChange={(e) => setSelectedDefinedChargeRate(e.target.value)}
                                            onBlur={(e) => {
                                                try {
                                                    if (e.target.value) {
                                                        const strippedValue = e.target.value.replace(/,/g, "");
                                                        if (isNaN(strippedValue)) {
                                                            setNotifyDialogTitle("Error!");
                                                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }
                                                        const parsedValue = parseFloat(strippedValue);
                                                        setSelectedDefinedChargeRate(formatAmountsToDecimals(parsedValue, 2));
                                                    }
                                                } catch (error) {
                                                    console.log(error)
                                                }
                                            }}
                                            style={{ width: "80px", textAlign: "right" }}
                                            className="form-input-item"
                                        />
                                    </div>
                                </div>}
                            {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center" }}>
                                    <div className="input-item-with-label">
                                        <label htmlFor="treaty_name"
                                            className="form-input-label"
                                            style={{ width: "100px" }}>
                                            {t('tax').toUpperCase()}
                                        </label>
                                        <Select
                                            id="part_tax"
                                            name="part_tax"
                                            menuPortalTarget={document.body}
                                            styles={{
                                                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                })
                                            }}
                                            width="350px"
                                            value={selectedDefinedTax}
                                            onChange={(selectedOption) => setSelectedDefinedTax(selectedOption)}
                                            options={definedCharges}
                                            isClearable
                                            isSearchable={true}
                                            placeholder={t('tax').toUpperCase()}
                                        />
                                        <span style={{ width: "3px" }} />
                                        <input
                                            id="definedTaxRate"
                                            name="definedTaxRate"
                                            type="text"
                                            value={selectedDefinedTaxRate}
                                            onChange={(e) => setSelectedDefinedTaxRate(e.target.value)}
                                            onBlur={(e) => {
                                                try {
                                                    if (e.target.value) {
                                                        const strippedValue = e.target.value.replace(/,/g, "");
                                                        if (isNaN(strippedValue)) {
                                                            setNotifyDialogTitle("Error!");
                                                            setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        }
                                                        const parsedValue = parseFloat(strippedValue);
                                                        setSelectedDefinedTaxRate(formatAmountsToDecimals(parsedValue, 2));
                                                    }
                                                } catch (error) {
                                                    console.log(error)
                                                }
                                            }}
                                            style={{ width: "80px", textAlign: "right" }}
                                            className="form-input-item"
                                        />
                                    </div>
                                </div>}
                            {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                <div style={{ display: "flex", flexDirection: "row", width: "100%", justifyContent: "center", alignItems: "center" }}>
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        borderRadiusType="both"
                                        variant="tint"
                                        color="#0ea5a4"
                                        width={"300px"}
                                        tooltip={"Apply charge to selected participant"}
                                        endIcon={<MdAdd />}
                                        onClick={async () => {
                                            try {
                                                let url = null;

                                                console.log(`destination ${selectedParticipant?.destination}`);
                                                if (selectedParticipant?.destination === "surplus") {
                                                    url = "/treatyCover/addSurplusCharge";
                                                } else if (selectedParticipant?.destination === "qs") {
                                                    url = "/treatyCover/addQsCharge";
                                                } else if (selectedParticipant?.destination === "cqs") {
                                                    url = "/treatyCover/addCqsCharge";
                                                }

                                                if (!url) {
                                                    showToast("Unable to set destination url", "error");
                                                    return;
                                                }

                                                if (!selectedParticipant?.docid) {
                                                    showToast("Participant document id not found", "error");
                                                    return;
                                                }

                                                const res = await newRequest.post(url, {
                                                    cover_docid: selectedTreatyCover?._id,
                                                    limit_docid: selectedCoverLimit?._id,
                                                    participant_id: selectedParticipant?.docid,
                                                    charge_code: selectedDefinedCharge?.value,
                                                    charge_rate: parseFloat(formatNumber((selectedDefinedChargeRate || 0), 6)),
                                                    charge_tax_code: selectedDefinedTax?.value || null,
                                                    charge_tax_rate: !selectedDefinedTax?.value ? 0 : parseFloat(formatNumber((selectedDefinedTaxRate || 0), 6)),
                                                    charge_basis: "Premium"
                                                });

                                                if (res.data.msg === "added") {
                                                    const addedDoc = res.data.doc;

                                                    const formattedLine = {
                                                        ...addedDoc,
                                                        charge_rate: formatNumber(addedDoc?.charge_rate || 0, 6),
                                                        charge_tax_rate: formatNumber(addedDoc?.charge_tax_rate || 0, 6),
                                                    };

                                                    setParticipantCharges((prev) => [...prev, formattedLine]);
                                                } else if (res.data.msg === "updated") {
                                                    const updatedDoc = res.data.doc;

                                                    const formattedLine = {
                                                        ...updatedDoc,
                                                        charge_rate: formatNumber(updatedDoc?.charge_rate || 0, 6),
                                                        charge_tax_rate: formatNumber(updatedDoc?.charge_tax_rate || 0, 6),
                                                    };

                                                    setParticipantCharges((prev) =>
                                                        prev.map((row) =>
                                                            row._id === updatedDoc._id ? formattedLine : row
                                                        )
                                                    );
                                                }
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {t('addNewCharge')}
                                    </CustomLoadingButton>
                                </div>}
                            {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) && <span className="separator-h" />}
                            <span className="normal-title">{t('currentApplicableCharges').toUpperCase()}</span>

                            {participantCharges?.length === 0 ?
                                <span className="main-title">{t('none').toUpperCase()}</span>
                                : <div className="table-content">
                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                            <TableBody className="tablebody" style={{ width: "100%" }}>
                                                {participantCharges?.map((row, index) => (
                                                    <TableRow
                                                        key={row?._id}
                                                        className={`${selectedPartChargeRow?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                        onClick={() => setSelectedPartChargeRow(row)}
                                                    >
                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                            <div className="part-charges-wrapper">
                                                                <div className="charges-row">
                                                                    <div className="charges-left">
                                                                        <span>{row?.charge_code_xx}</span>
                                                                    </div>
                                                                    <div className="charges-right">
                                                                        <div className="input-item-with-label">
                                                                            <input
                                                                                id="charge_rate"
                                                                                name="charge_rate"
                                                                                type="text"
                                                                                value={row?.charge_rate}
                                                                                onChange={(e) => handlePartCharge(e, row._id, 'charge_rate')}
                                                                                onBlur={() => handlePartChargeBlur(row._id, "charge_rate")}
                                                                                style={{ width: "100%", textAlign: "right" }}
                                                                                className="form-input-item table"
                                                                                disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {row?.charge_tax_code &&
                                                                    <div className="charges-row">
                                                                        <div className="charges-left">
                                                                            <span>{`${t('tax')} : ${row?.charge_tax_code_xx}`}</span>
                                                                        </div>
                                                                        <div className="charges-right">
                                                                            <div className="input-item-with-label">
                                                                                <input
                                                                                    id="charge_tax_rate"
                                                                                    name="charge_tax_rate"
                                                                                    type="text"
                                                                                    value={row?.charge_tax_rate}
                                                                                    onChange={(e) => handlePartCharge(e, row._id, 'charge_tax_rate')}
                                                                                    onBlur={() => handlePartChargeBlur(row._id, "charge_tax_rate")}
                                                                                    style={{ width: "100%", textAlign: "right" }}
                                                                                    className="form-input-item table"
                                                                                    disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>}
                                                                <CustomRadioGroup
                                                                    id="chargeApplOn"
                                                                    value={row?.charge_basis}
                                                                    onChange={(next) => handlePartCharge(next, row._id, 'charge_basis')}
                                                                    label={row?.charge_basis}
                                                                    labelPosition="end"
                                                                    labelWidth="max-content"
                                                                    disabled={["Approved", "Suspended"].includes(selectedTreaty?.treaty_status)}
                                                                    options={["Premium", "Sum Insured"].map((v) => ({ value: v, label: v }))}
                                                                />
                                                            </div>
                                                        </TableCell>
                                                        {!["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                                                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                <CircularButton
                                                                    currentTheme={currentTheme}
                                                                    onClick={async (e) => {
                                                                        try {
                                                                            if (!selectedTreatyCover?._id) {
                                                                                showToast("Select cover", "error");
                                                                                return;
                                                                            }
                                                                            if (!selectedCoverLimit?._id) {
                                                                                showToast("Select limit", "error");
                                                                                return;
                                                                            }
                                                                            if (!selectedParticipant?.docid) {
                                                                                showToast("Participant document id not found", "error");
                                                                                return;
                                                                            }
                                                                            let url = null;

                                                                            console.log(`destination ${selectedParticipant?.destination}`);
                                                                            if (selectedParticipant?.destination === "surplus") {
                                                                                url = "/treatyCover/delSurplusCharge";
                                                                            } else if (selectedParticipant?.destination === "qs") {
                                                                                url = "/treatyCover/delQsCharge";
                                                                            } else if (selectedParticipant?.destination === "cqs") {
                                                                                url = "/treatyCover/delCqsCharge";
                                                                            }

                                                                            if (!url) {
                                                                                showToast("Unable to set destination url", "error");
                                                                                return;
                                                                            }

                                                                            // console.log(`url ... ${url}`);
                                                                            const res = await newRequest.post(url, {
                                                                                cover_docid: selectedTreatyCover?._id,
                                                                                limit_docid: selectedCoverLimit?._id,
                                                                                participant_id: selectedParticipant?.docid,
                                                                                charge_id: row?._id
                                                                            });
                                                                            if (res.data?.msg === "deleted") {
                                                                                setParticipantCharges((prev) => prev.filter(line => line?._id !== row?._id));
                                                                                showToast(t('deleted'), "success");
                                                                            } else {
                                                                                showToast("Error removing!", "error");
                                                                            }
                                                                        } catch (error) {
                                                                            console.log(error);
                                                                        }
                                                                    }} icon={<MdDelete />} width={"30px"} height={"30px"} />
                                                            </TableCell>}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>}
                        </div>
                        {participantCharges?.length > 0 &&
                            !["Approved", "Suspended"].includes(selectedTreaty?.treaty_status) &&
                            <div className="overlay-actions" style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#BA68C8"
                                    tooltip="Update changes"
                                    endIcon={<PiChecksBold />}
                                    onClick={updateParticipantCharges}>
                                    {t('update')}
                                </CustomLoadingButton>
                            </div>}
                    </div>
                </motion.div>
            )}
            {validationMsgDialog && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-content">
                            <ValidationMessages
                                messageData={validationMessagesResult}
                                onClose={() => setValidationMsgDialog(false)}
                                onFix={(row) => {/* focus field / navigate */ }}
                                onRemind={() => setValidationMsgDialog(false)}
                                onSupport={() => navigate("/support")}
                            />
                        </div>
                    </div>
                </motion.div>
            )}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <ScaleLoader
                            color="var(--primary)"
                            height={50}
                            radius={8}
                            width={4}
                        />
                    </div>
                </motion.div>
            )}
        </div>
    )
}



export default RiTreaty;